import MailIcon from '@raison/static/icons/mail-send-line.svg';
import React from 'react';
import {InlineSvg, RsnButton, RsnDialog} from '~/library/ui-kit';

export function FallbackVerificationDialog() {
    return (
        <RsnDialog.Window>
            <RsnDialog.CenteredHeader
                icon={{
                    element: (
                        <div className={'flex size-16 items-center justify-center rounded-full bg-neutral-20'}>
                            <InlineSvg src={MailIcon} className={'size-10 text-neutral-90'} />
                        </div>
                    ),
                }}
            >
                Trying another way
            </RsnDialog.CenteredHeader>
            <RsnDialog.Body>Check your SMS, Telegram, or WhatsApp messages.</RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Alike as={RsnDialog.CloseTrigger} intent='secondary'>
                    I got it
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
